var _path, _polygon, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTsx(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "&ns_svg;",
    xmlnsXlink: "&ns_xlink;",
    width: 234.467,
    height: 234.466,
    viewBox: "0 0 234.467 234.466",
    overflow: "visible",
    enableBackground: "new 0 0 234.467 234.466",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#003D7D",
    d: "M89.094,141.369H74.578l1.879,7.528h19.286c14.946,0,24.733-5.423,25.811-15.8 c1.855-17.887-27.509-22.687-27.509-30.961c0-3.581,2.964-5.935,9.891-5.935h12.05v-7.527c0,0-9.621,0-15.752,0 c-15.287,0-22.778,5.358-23.7,14.512c-1.64,16.264,23.565,19.672,25.219,29.668C102.67,138.365,97.692,141.369,89.094,141.369z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    fill: "#003D7D",
    points: "35.068,150.776 51.995,147.007 51.995,96.201 70.345,96.201 70.345,88.674 15.295,88.674  17.177,96.201 35.068,96.201 "
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#003D7D",
    d: "M209.616,71.686h-22.637c4.022-16.271,6.167-33.282,6.167-50.792l-14.189,5.675 c-2.593,91.554-67.762,167.458-154.252,186.454l-1.809,5.479c38.293-7.818,72.634-26.493,99.678-52.665h16.46l21.652-31.063 l21.642,31.063h27.288l-36.051-47.05L209.616,71.686z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#003D7D",
    d: "M154.77,103.604l-11.2-14.93h-18.818l22.423,29.234C150.091,113.607,152.876,108.484,154.77,103.604z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTsx);
export default __webpack_public_path__ + "static/media/tsx.d7bce784ab112bc5affe14186fe38361.svg";
export { ForwardRef as ReactComponent };